module AjaxSave {
	interface ISaveResponse {
		Success: Boolean;
		Message: string;
		NewValue: string;
	}

	interface ISaveRequest {
		ColumnId: string;
		RowId: string;
		Value: any;
	}

	let timeoutIDsByColumn: Dictionary<number>;
	const columnIdAttribute = "columnid";
	const rowIdAttribute = "rowid";
	const valueAttribute = "ajaxvalue";

	export function construct(): void {
		timeoutIDsByColumn = new Dictionary<number>();
		$(
			`
				input[data-${columnIdAttribute}],
				select[data-${columnIdAttribute}],
				textarea[data-${columnIdAttribute}]
			`
		).change(onElementChanged);
	}

	function onElementChanged(): void {
		const element = $(this);

		if (element.hasClass("disabled"))// || element[0].hasAttribute("readonly")//For checkable datetime boxes we want to be able to programmatically change and persist their values and use readonly to prevent user input
		{
			return;
		}

		if (!getValueComplete(element)) {
			return;
		}

		const columnid = String(element.data(columnIdAttribute));
		const rowid = getRowId(element);
		const value = getValue(element);
		const callback = getCallbackFunction(element);

		updateDatabase(columnid, rowid, value, callback);
	}

	export function updateDatabase(columnid: string, rowid: string, value: any, callback: () => any = null): void {
		//Date object in JS doesn't support time zones so everything is off by the UTC offset if we just pass it to Web API.
		if (value instanceof Date) {
			value = moment(value as Date).format();
		}

		//Used as an identifier for the timer in the Dictionary of existing timers.
		const lookupKey = columnid + rowid;

		const existingTimeoutId = timeoutIDsByColumn.ItemOrNull(lookupKey);
		if (existingTimeoutId != null) {
			clearTimeout(existingTimeoutId);
			timeoutIDsByColumn.Remove(lookupKey);
		}

		const timeoutId = setTimeout(() => submitRequest(columnid, rowid, value, callback), 10);
		timeoutIDsByColumn.Add(lookupKey, timeoutId);
	}

	function getValue(element: JQuery<HTMLElement>): string {
		if (element.data(valueAttribute)) {
			return element.data(valueAttribute);
		}

		if (element.is("input[type=checkbox]")) {
			return element.is(":checked").toString();
		}

		return element.val() as any as string;
	}

	export function getRowId(element: JQuery<HTMLElement>): string {
		return String(DataAttributeTools.DataForElementOrParents(element, rowIdAttribute));
	}

	function submitRequest(columnId: string, rowid: string, value: string, callback: () => any = null): void {
		const longRequestTimerId = setTimeout(notifyLongRequest, 500);
		var payload =
			{
				ColumnId: columnId,
				RowId: rowid,
				Value: value
			} as ISaveRequest;
		$.ajax(
			"/Api/Orm/AjaxSave",
			{
				data: JSON.stringify(payload),
				contentType: "application/json; charset=utf-8",
				dataType: "json",
				type: "POST",
				timeout: 5000,
				success: function (response: ISaveResponse) {
					notifySuccess(response);
					if (callback != null) {
						callback();
					}
				},
				error: notifyFailure,
				complete: () => clearTimeout(longRequestTimerId)
			}
		);
	}

	function notifySuccess(response: ISaveResponse): void {
		if (response.Success) {
			//Notifications.ChangeSaved();
		} else {
			notifyFailure(); //response.Message
		}
	}

	function notifyFailure(error: object = null): void {
		Notifications.Warning(
			"Your change could not be saved to the server!  Please contact support with a link to the Claim, what field you were changing, and what you were attempting to enter into the field.",
			"Field Save Failure"
		);
	}

	function notifyLongRequest(): void {
		Notifications.Warning(
			"The server is still processing your request to update this field but has not yet completed it.  Please do not close the page until the request succeeds or fails.  If this continues more than 10 seconds please reload the page and try again.",
			"Field Save Delayed"
		);
	}

	function getCallbackFunction(element: JQuery<HTMLElement>): () => void {
		var dataParameter = element.data("onsaved");
		if (!dataParameter) {
			return null;
		}
		return window[<string>dataParameter];
	}

	function getValueComplete(element: JQuery<HTMLElement>): boolean {
		var val = element.val();
		var inputType = element.attr("type");
		if (inputType == "date") {
			return val.toString().charAt(0) !== "0";//Only accept 4 digit years.
		}
		if (inputType == "datetime-local") {
			return true;//todo implement
		}
		return true;
	}
}